const STEPS = {
  LANDING: "LANDING",
  SUBMITTING: "SUBMITTING",
  COMPLETE: "COMPLETE",
  CPD_STATUS_CONFIRM: "CPD_STATUS_CONFIRM",
};
export default STEPS;
